export default __webpack_public_path__ + "static/media/matematika.0157372e.svg";